<template>
    <b-container fluid >
        <b-row v-if="companies">
            <b-col cols="12" class="p-2 d-flex justify-content-between">
                <h1>Companies</h1>
                <div class="w-25 flex-center">
                    <b-btn variant="primary"
                           class="w-100"
                           v-b-modal.new-company>New Company</b-btn>
                </div>
            </b-col>
            <b-col>
                <adam-table
                        position
                        :items="companies"
                        :fields="fields"
                        :search-keys="searchKeys"
                        @rowClicked="editCompany"
                        class="white-bg">
                </adam-table>
            </b-col>
        </b-row>
        <b-modal centered
                 hide-footer
                 ref="new-company"
                 title="New company"
                 id="new-company">
            <adam-form
                    :fields="formFields"
                    submit="Submit"
                    post="companies"
                    @success="formSuccess">
            </adam-form>
        </b-modal>
        <b-modal centered
                 hide-footer
                 ref="edit-company"
                 title="Edit company"
                 id="edit-company">
            <adam-form
                    v-if="selectedCompany"
                    :fields="formFields"
                    submit="Update"
                    :post="'companies' + '/' + selectedCompany.id"
                    :item="selectedCompany"
                    @success="formSuccess">
            </adam-form>
        </b-modal>

    </b-container>
</template>

<script>
    import AdamForm from "../components/AdamForm";
    import AdamTable from "../components/AdamTable";
    export default {
        components: {AdamTable, AdamForm},
        data() {
            return {
                companies: null,
                selectedCompany: null,
                currentPage: 1,
                perPage: 10,
                fields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    }
                ],
                searchKeys: ['name'],
                formFields: [
                    {
                        key: 'name',
                        label: 'Name',
                        type: 'text',
                        required: true,
                    }
                ]
            }
        },
        methods: {
            getCompanies() {
                adamApi.get(api.companies)
                    .then(response => {
                        if (response.status === 200) {
                            this.companies = response.data
                        }
                    });
            },
            formSuccess() {
                this.getCompanies();
                this.$refs['new-company'].hide();
                this.$refs['edit-company'].hide();
            },
            editCompany(selected) {
                this.selectedCompany = this.companies.find(company => {return company.id === selected.id});
                this.$refs['edit-company'].show();
            }
        },
        created () {
            this.getCompanies();
        }
    }
</script>
